<!--
 * @Author: xiaopeiting
 * @Date: 2020-06-01 18:07:39
 * @LastEditTime: 2020-06-13 14:25:29
--> 
<template>
  <div>
    <div
      class="bottom-wrapper"
      :class="{
        'has-disagree': !agreeStatus,
        'high-index': isShowChannelModal,
      }"
    >
      <!-- 支付 -->
      <template v-if="bottomType === 'pay'">
        <div
          ref="applyBlock"
          class="btn-pay dis-flex flex-between flex-middle"
          :style="{ background: bgColour }"
        >
          <slot name="pay-info"></slot>
          <div @click="handleClickBtn">
            <slot name="pay-btn"></slot>
          </div>
        </div>
        <div class="btn-switch">
          <ChannelSwitch
            :canSelect="supportPayType.length > 1"
            :config="payConfig"
            @change="handleChannelChange"
          ></ChannelSwitch>
        </div>
        <!-- 选择支付方式 -->
        <ModalChannelSelect
          :bottomDistance="channelModalBottomDistance"
          :toggle="isShowChannelModal"
          :supportType="supportPayType"
          :defaultType="defaultPayment"
          @close="isShowChannelModal = false"
          @change="(config) => (payConfig = config)"
        ></ModalChannelSelect>
      </template>

      <!-- 添加公众号/助教 -->
      <div
        v-if="bottomType === 'follow'"
        class="modal-block dis-flex flex-middle flex-center"
        :style="{
          color: bottomData.button.color,
          background: bottomData.button.bgcolor,
        }"
        @click="showModal"
      >
        <div class="vertical flex-center flex-middle">
          <div class="modal-desc">{{ btnContent }}</div>
          <div v-if="bottomData.button.tips" class="modal-tips">
            {{ bottomData.button.tips }}
          </div>
        </div>
        <div class="icon-next" />
      </div>

      <!-- 重定向 -->
      <div
        v-if="bottomType === 'redirect'"
        class="modal-block vertical flex-middle flex-center"
        :style="{
          color: bottomData.button.color,
          background: bottomData.button.bgcolor,
        }"
        @click="redirect(bottomData.button.redirect_url)"
      >
        <div class="modal-desc">{{ btnContent }}</div>
        <div v-if="bottomData.button.tips" class="modal-tips">
          {{ bottomData.button.tips }}
        </div>
        <div class="icon-next" />
      </div>
    </div>

    <div v-if="!agreeStatus" class="disagree">{{ agreeText }}</div>

    <!-- 底部弹窗模式 -->
    <div
      v-if="btnModal && btnModal.type === 'align-bottom' && isShowModal"
      class="align-bottom"
      :style="{ backgroundImage: 'url(' + bgImgRes + ')' }"
    >
      <span v-if="modalRes" class="modal-content">
        <span
          v-for="(item, index) in modalRes"
          :key="index"
          class="content-item"
          v-html="item"
        ></span>
      </span>
      <div v-if="btnModal && btnModal.qrcode" class="qr-wrap">
        <img :src="btnModal.qrcode" alt class="qr" />
      </div>
      <span v-if="btnModal.tips" class="label" v-html="btnModal.tips"></span>
      <img v-if="iconImgRes" :src="iconImgRes" alt class="success-symbol" />
    </div>

    <!-- 居中弹窗模式-滑动出现 -->
    <div
      v-if="btnModal && btnModal.type === 'align-center' && btnModal.appearance"
      class="align-center"
    >
      <transition
        enter-active-class="animated fadeInUp"
        leave-active-class="animated fadeOutUp"
      >
        <div
          v-if="btnModal && btnModal.type === 'align-center' && isShowModal"
          class="modal-mask"
          @click.self="closeModal"
        >
          <div
            class="modal-panel"
            :style="{ backgroundImage: 'url(' + bgImgRes + ')' }"
          >
            <span v-if="modalRes" class="panel-content">
              <span
                v-for="(item, index) in modalRes"
                :key="index"
                class="panel-item"
                v-html="item"
              ></span>
            </span>
            <img class="qrcode" :src="btnModal.qrcode" alt />
            <img v-if="iconImgRes" class="finger-icon" :src="iconImgRes" alt />
            <p
              v-if="btnModal.tips"
              class="footer-desc"
              v-html="btnModal.tips"
            ></p>
          </div>
        </div>
      </transition>
    </div>

    <!-- 居中弹窗模式-默认出现 -->
    <div v-else class="align-center">
      <div
        v-if="btnModal && btnModal.type === 'align-center' && isShowModal"
        class="modal-mask"
        @click.self="closeModal"
      >
        <div
          class="modal-panel"
          :style="{ backgroundImage: 'url(' + bgImgRes + ')' }"
        >
          <span v-if="modalRes" class="panel-content">
            <span
              v-for="(item, index) in modalRes"
              :key="index"
              class="panel-item"
              v-html="item"
            ></span>
          </span>
          <img class="qrcode" :src="btnModal.qrcode" alt />
          <img v-if="iconImgRes" class="finger-icon" :src="iconImgRes" alt />
          <p
            v-if="btnModal.tips"
            class="footer-desc"
            v-html="btnModal.tips"
          ></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang='ts'>
import { Vue, Component, Prop, Mixins, Watch } from 'vue-property-decorator';
import {
  ChannelSwitch,
  ModalChannelSelect,
  allChannels,
  PayTypes,
  IPayType,
} from '@/modules/common/MutiPayChannel';
import { handlePayment } from '@/modules/common/helps';
import { getQueryFromSearch } from '@/lib/util';

@Component({
  components: {
    ChannelSwitch,
    ModalChannelSelect,
  },
})
export default class Popup extends Vue {
  @Prop({ require: true }) bottomType!: string;
  @Prop({ default: '#fff' }) bgColour!: string;
  @Prop({ default: true }) agreeStatus!: boolean;
  @Prop({ default: false }) expiredStatus!: boolean;
  @Prop({}) bottomData!: any;
  @Prop({}) isShowExpand!: boolean;
  @Prop({}) supportPayType!: [];
  @Prop({ default: '' }) defaultPayment!: string;
  @Prop({ default: '*请阅读并勾选 《风变编程报名须知》《隐私政策》' })
  agreeText!: string;

  isShowModal = false;
  payConfig: IPayType = {} as any;
  channelModalBottomDistance = '0px';
  isShowChannelModal = false;
  isShowRepayModal = false;
  payLock = false;

  get btnContent() {
    return (this.bottomData && this.bottomData.button.content) || '';
  }

  get btnModal() {
    if (this.bottomData && this.bottomData.button.modal) {
      return this.bottomData.button.modal;
    }
    return null;
  }

  get bgImgRes() {
    if (
      this.btnModal &&
      Array.isArray(this.btnModal.images) &&
      this.btnModal.images.length
    ) {
      return this.btnModal.images[0];
    }
    return '';
  }

  get modalRes() {
    if (
      this.btnModal &&
      Array.isArray(this.btnModal.content) &&
      this.btnModal.content.length
    ) {
      return this.btnModal.content;
    }
    return '';
  }

  get iconImgRes() {
    if (
      this.btnModal &&
      Array.isArray(this.btnModal.images) &&
      this.btnModal.images.length
    ) {
      return this.btnModal.images[1];
    }
    return '';
  }

  @Watch('defaultPayment', { immediate: true })
  getPayConfig(newVal: PayTypes, oldVal: PayTypes) {
    if (newVal !== oldVal) {
      this.payConfig = allChannels[newVal];
    }
  }

  redirect(url: string) {
    window.location.replace(url);
  }

  toggleShowCouponModal(status: boolean) {
    const couponModal = this.$refs.couponModal;
    if (couponModal) {
      couponModal.toggleModal(true);
    }
  }

  getBottomDistance(el: HTMLElement) {
    if (!el) {
      return 0;
    }
    const { height, bottom } = getComputedStyle(el);
    return parseFloat(height) + parseFloat(bottom);
  }

  handleChannelChange() {
    this.channelModalBottomDistance =
      this.getBottomDistance(this.$refs.applyBlock) + 'px';
    this.$nextTick(() => {
      this.isShowChannelModal = true;
    });
  }

  showModal() {
    const page: HTMLElement = document.querySelector(
      '#page-wrapper'
    ) as HTMLElement;

    if (!page) {
      return;
    }
    this.isShowModal = true;
    page.style.position = 'fixed'; // 禁止蒙层底部页面滚动
  }

  closeModal() {
    const page: HTMLElement = document.querySelector(
      '#page-wrapper'
    ) as HTMLElement;

    if (this.btnModal && this.btnModal.is_close && page) {
      page.style.position = '';
      this.isShowModal = false;
    }
  }

  handlePay() {
    if (this.payLock) {
      return;
    }
    this.payLock = true;

    handlePayment(
      this.bottomData.button.production_id,
      {
        channel: this.payConfig.channel,
        result_url: window.location.href,
      },
      {
        ...this.$route.query,
        ...getQueryFromSearch(),
      }
    )
      .then(() => {
        this.isShowChannelModal = false;
        this.payLock = false;
        this.$emit('apply-success');
      })
      .catch((err: any) => {
        this.payLock = false;
      });
  }

  handleClickBtn() {
    if (!this.agreeStatus || this.expiredStatus) {
      return;
    }
    this.handlePay();
  }
}
</script>

<style lang="scss" scoped>
@import '../../style/flex.css';

$content-color: white;
$bg: linear-gradient(90deg, #ff2e7f, #c700ff);

.bottom-wrapper {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;

  &.has-disagree {
    .btn-pay {
      bottom: 34px;
      // padding-bottom: calc(constant(safe-area-inset-bottom));
      // padding-bottom: calc(env(safe-area-inset-bottom));
    }
    .btn-switch {
      bottom: 142px;
      // padding-bottom: calc(constant(safe-area-inset-bottom));
      // padding-bottom: calc(env(safe-area-inset-bottom));
    }
  }

  &.high-index {
    z-index: 10;
  }
}
.btn-pay {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 1300;
  box-sizing: content-box;
  width: 100%;
  // background: $bg;
  // color: $content-color;
  // padding: 24px 24px;
  height: 108px;
  padding-bottom: calc(constant(safe-area-inset-bottom));
  padding-bottom: calc(env(safe-area-inset-bottom));

  // .info-wrap {
  //   height: 180px;

  //   .content {
  //     font-size: 48px;
  //     font-weight: 600;
  //   }
  //   .desc {
  //     font-size: 24px;
  //     color: #ffef82;
  //     margin-top: 10px;
  //   }
  //   .tags {
  //     flex-wrap: wrap;
  //     margin-bottom: -12px;
  //     margin-top: 22px;

  //     .tag {
  //       height: 50px;
  //       line-height: 48px;
  //       border: 2px solid rgba(255, 255, 255, 0.49);
  //       padding: 0 12px;
  //       color: #fff;
  //       font-size: 24px;
  //       font-weight: 500;
  //       border-radius: 25px;
  //       margin-right: 16px;
  //       margin-bottom: 12px;

  //       &:nth-child(2n) {
  //         margin-right: 0;
  //       }
  //     }
  //   }
  // }
  // .btn-wrap {
  //   width: 300px;
  //   height: 180px;
  //   // margin-left: 12px;
  //   border-radius: 24px;
  //   background: linear-gradient(#ffb321, #ff6e00);

  //   &.disable {
  //     background: linear-gradient(#ffe4b2, #ffc294);
  //   }
  //   .price {
  //     font-size: 96px;
  //     font-weight: 600;
  //     line-height: 80px;
  //     font-family: PingFangSC-Semibold, PingFang SC;
  //     .rmb {
  //       font-size: 56px;
  //       margin-right: -36px;
  //     }
  //   }
  //   .text {
  //     font-size: 32px;
  //     font-weight: 500;
  //   }
  // }
}
.btn-switch {
  position: fixed;
  bottom: 108px;
  left: 0;
  box-sizing: content-box;
  padding-bottom: calc(constant(safe-area-inset-bottom));
  padding-bottom: calc(env(safe-area-inset-bottom));
}

.modal-block {
  position: relative;
  z-index: 10;
  box-sizing: content-box;
  height: 120px;
  padding-bottom: constant(safe-area-inset-bottom); /* 兼容 iOS < 11.2 */
  padding-bottom: env(safe-area-inset-bottom);
  font-weight: 600;
  // color: $content-color;
  font-size: 48px;
  // background: $bg;

  .modal-desc {
    font-weight: 600;
    font-size: 40px;
    letter-spacing: 6px;
  }
  .modal-tips {
    font-size: 20px;
    letter-spacing: 2px;
    opacity: 0.8;
  }
  .icon-next {
    position: absolute;
    top: 50%;
    right: 24px;
    width: 40px;
    height: 40px;
    // background-color: $content-color;
    background-image: url('./assets/icon-next.png');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 40px 40px;
    border-radius: 50%;
    transform: translateY(-50%);
    // margin-left: 30px;
  }
}
.disagree {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 1300;
  width: 100%;
  height: 34px;

  // bottom: calc(constant(safe-area-inset-bottom));
  // bottom: calc(env(safe-area-inset-bottom));
  padding-bottom: calc(constant(safe-area-inset-bottom));
  padding-bottom: calc(env(safe-area-inset-bottom));
  color: #fff;
  font-size: 20px;
  text-align: center;
  background-color: #fa6a6a;
}
.align-bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 750px;
  padding-top: 225px;
  padding-bottom: 40px;
  background-color: #ffffff;
  background-size: 100% 100%;
  border-radius: 30px 30px 0 0;

  .success-symbol {
    width: 100px;
    height: 100px;
  }

  .modal-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .qr-wrap {
    margin-top: 25px;
    padding: 12px;
    background-color: #f1f1f6;
    border-radius: 6px;

    .qr {
      width: 236px;
      height: 236px;
      background-color: #ffffff;
      border-radius: 6px;
    }
  }

  .label {
    margin-top: 14px;
    color: #1f2d3d;
    font-weight: 500;
    font-size: 22px;
    opacity: 0.5;
  }
}
.align-center {
  .modal-mask {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.72);

    .modal-panel {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 630px;
      height: 980px;
      padding-top: 287px;
      padding-bottom: 60px;
      background: #fff;
      background-size: 100% 100%;
      border-radius: 10px;

      .feed-back {
        position: absolute;
        top: 24px;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 44px;
        padding-right: 10px;
        padding-left: 15px;
        color: #fff;
        font-weight: 300;
        font-size: 20px;
        background: rgba($color: #979797, $alpha: 0.4);
        border: none;
        border-radius: 63px 0 0 63px;
        img {
          width: 18px;
          height: 18px;
          margin-right: 5px;
        }
      }

      .panel-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
      .qrcode {
        width: 300px;
        height: 300px;
        margin-top: 29px;
        border: 15px solid #f1f1f6;
        border-radius: 6px;
      }
      .finger-icon {
        width: 70px;
        height: 70px;
        margin-top: 40px;
      }
      .footer-desc {
        margin-top: 10px;
        color: #1f2d3d;
        font-weight: 500;
        font-size: 26px;
      }
    }
  }
}
</style>
